import { Button, Col, Divider, Drawer, Image, Row } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined, FileImageOutlined } from "@ant-design/icons";
import moment from "moment";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {/* <Typography style={{ fontWeight: "bold", fontStyle: "italic" }}> */}
    <b>
      <i>{content}</i>
    </b>
    {/* </Typography> */}
  </div>
);

const MerchantPaymentDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  // const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [visible, setVisible] = useState(false);
  const scaleStep = 0.5;

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      invoice_number: selectedData !== null ? selectedData.invoice_number : "",
    };
    axios
      .get("user/commissary/spec-invoice-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        // setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      // setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Merchant Payment Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {orderDetailsList.ready && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
          >
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Payment</p>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Method"
                content={`${orderDetailsList.data[0].payment_method}`}
              />
            </Col>
          </Row>
          {orderDetailsList.data[0].payment_method === "ecash" && (
            <Row>
              <Col span={24}>
                <DescriptionItem
                  title="Reference #"
                  content={`${orderDetailsList.data[0].ref_no}`}
                />
              </Col>
            </Row>
          )}
          {orderDetailsList.data[0].payment_method !== "cash" &&
            orderDetailsList.data[0].payment_method !== "ecash" && (
              <>
                <Row>
                  <Col span={24}>
                    <DescriptionItem
                      title="Bank Name"
                      content={`${orderDetailsList.data[0].bank_name}`}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <DescriptionItem
                      title="Account No."
                      content={`${orderDetailsList.data[0].account_no}`}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <DescriptionItem
                      title="Check No."
                      content={`${orderDetailsList.data[0].check_no}`}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <DescriptionItem
                      title="Check Date"
                      content={`${moment(
                        new Date(orderDetailsList.data[0].check_date),
                        "YYYY-MM-DD"
                      ).format("MMMM DD, YYYY")}`}
                    />
                  </Col>
                </Row>
              </>
            )}
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Payment Amount"
                content={`${orderDetailsList.data[0].amount}`}
              />
            </Col>
          </Row>

          {orderDetailsList.data[0].discount_category !== null && (
            <Row>
              <Col span={24}>
                <DescriptionItem
                  title={`Discount ${
                    orderDetailsList.data[0].discount_category === "percentage"
                      ? `${orderDetailsList.data[0].discount_percentage}%`
                      : ""
                  }`}
                  content={orderDetailsList.data[0].discount_amount.toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                />
              </Col>
            </Row>
          )}
          <Divider />
        </div>
      )}

      {/* IMAGE VIEW */}
      {orderDetailsList.data.length > 0 &&
        orderDetailsList.data[0].payment_method === "ecash" && (
          <div>
            <Image
              width={200}
              style={{
                display: "none",
              }}
              src=""
              preview={{
                visible,
                scaleStep,
                src: `${process.env.REACT_APP_API_IMAGE}payment/${orderDetailsList.data[0].payment_attachment}`,
                onVisibleChange: (value) => {
                  setVisible(value);
                },
              }}
            />
          </div>
        )}

      {orderDetailsList.data.length > 0 &&
        orderDetailsList.data[0].payment_method === "ecash" && (
          <Button
            type="default"
            icon={<FileImageOutlined />}
            onClick={() => setVisible(true)}
            style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
          >
            Payment Attachment
          </Button>
        )}

      <Button
        type="primary"
        onClick={handlePrint}
        icon={<PrinterOutlined />}
        style={{ width: "100%", borderRadius: "20px", marginTop: 10 }}
      >
        Print
      </Button>
    </Drawer>
  );
};

export default MerchantPaymentDetails;
